import { cn } from "@/utils/cn";

export default function LoadingSpiner({
  msg,
  className,
  size = "md",
  indicatorClassName,
}: {
  msg?: string;
  className?: string;
  size?: "sm" | "md";
  indicatorClassName?: string;
}) {
  const arr = [...Array(12)];
  const spinnerSizeClass = size === "sm" ? "size-3" : "size-4";
  const indicatorSizeClass =
    size === "sm" ? "w-[2px] h-[7px]" : "w-[3px] h-[9px]";

  return (
    <div
      className={cn(
        "items-center w-full    flex justify-center relative",
        className
      )}
    >
      <div className={cn("relative", spinnerSizeClass)}>
        {arr.map((_, idx) => (
          <span
            className={cn(
              "absolute origin-bottom rounded-md animate-opacity-infinity",
              indicatorSizeClass,
              indicatorClassName ?? "bg-foreground"
            )}
            style={{
              animationDelay: `${idx * 0.1}s`,
              transform: `rotate(${idx * 30}deg) translateY(-80%)`,
            }}
            key={idx}
          />
        ))}
      </div>
      {msg ? (
        <div className="ml-5 text-accent-foreground  text-base font-pretendard">
          {msg}
        </div>
      ) : undefined}
    </div>
  );
}
